const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const Licenses = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "LICENSES_REQUEST":
      return { loading: true, error: false, data: [] };
    case "LICENSES_ERROR":
      return { loading: false, error: true, data: [] };
    case "LICENSES_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    case "LICENSES_RESET":
      return { loading: false, error: false, data: [] };
    default:
      return state;
  }
};

export default Licenses;
